import axios from "axios";

import { auth } from "@Firebase/firebase";
import { CreateNoteRequest, LenderNote } from "@Types/notes";

export const createLenderNote = (): ((
  note: CreateNoteRequest
) => Promise<LenderNote>) => {
  return async (note) => {
    const token = await auth.currentUser?.getIdToken();

    const response = await axios.post(
      `${process.env.REACT_APP_HTTP_URL}/lender-api/v1/lender_note/`,
      note,
      {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    return response.data.result;
  };
};
